export const darkTheme = {
    bg: "#121212", // Deep dark background for a modern look
    bgLighter: "#1F1F1F", // Slightly lighter shade for sections
    itemHover: "#3A3A3A", // Soft hover effect
    itemText: "#E0E0E0", // Light text for contrast
    primary: "#6A5ACD", // Soft purple for primary actions
    bgDark: "#181818", // Darker shade for contrast
    text: "#EAEAEA", // Very light text
    textSoft: "#B0B0B0", // Softer secondary text
    soft: "#282828", // Dark but not pitch black
    soft2: "#A3A3A3", // Slightly brighter soft color
    card: "#2D2D2D", // Dark card background
    lightAdd: "99",
    yellow: "#FFEA00", // Bright yellow for highlights
    green: "#76FF03", // Vivid green for positive actions
    pink: "#FF4081", // Bright pink for accents
    recieve_message: "#1E1E1E", // Dark for message background
    chat_background: "#0F0F0F", // Darker chat background for depth
    send_message: "#7C4DFF", // Soft purple for sent messages
    contact_background: "#181818", // Consistent with the theme




    /*Colors
Swatch 1
#030405
Swatch 2
#585759
Swatch 3
#03840c
Swatch 4
#acb0b3
Swatch 5
#185c1a
Swatch 6
#40b957*/
}

export const lightTheme = {
    bg:"#F8F9FD",
    bgLighter:"#FFFFFF",
    itemHover: "#F7F5F4",
    itemText:"#555F61",
    primary: "#854CE6",
    bgDark:"white",
    text:"#2F2F2F",
    textSoft:"#606060",
    soft:"#C4C4C4",
    soft2:"#757575",
    card: "#FFFFFF",
    lightAdd:"",
    recieve_message: "#ffffff",
    chat_background: "#f5f5fc",
    send_message: "#4f34ad",
    send_message_text_color: "#ffffff",
    contact_background: "#ffffff",

  }